import propTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const sizes = {
  body: {
    desktop: '14px',
    mobile: '13px',
  },
  caption: {
    desktop: '14px',
    mobile: '12px',
  },
  footer: {
    desktop: '12px',
    mobile: '10px',
  },
  header: {
    desktop: '40px',
    mobile: '28px',
  },
  subtitle: {
    desktop: '20px',
    mobile: '17px',
  },
  title: {
    desktop: '28px',
    mobile: '22px',
  },
};

const Paragraph = ({ children, textAlign, color, type = 'body' }) => {
  const style = {
    color,
    // Default to 'left' if no textAlign is provided
    textAlign: textAlign || 'left',
  };
  const theme = useContext(ThemeContext);

  return (
    <>
      <p className="paragraph" style={style}>
        {children}
      </p>
      <style jsx>
        {`
          .paragraph {
            font-size: ${sizes[type].mobile};
          }
          /* Desktop version*/
          @media (min-width: ${theme.breakpoints.lgUp}) {
            .paragraph {
              font-size: ${sizes[type].desktop};
            }
          }
        `}
      </style>
    </>
  );
};

Paragraph.propTypes = {
  children: propTypes.node.isRequired,
  color: propTypes.string,
  // Validate that children is a valid React node
  textAlign: propTypes.oneOf(['left', 'center', 'right', 'justify']),

  type: propTypes.string,
};
export default Paragraph;

// add props -- color
